import React, { Component, Fragment } from "react";
import User_panel from "./user-panel";
import { Link } from "react-router-dom";
import {
  MENUITEMSFORADMIN,
  MENUITEMSFORACCOUNTS,
  MENUITEMSFOREMPLOYEE,
  MENUITEMSFOROFFICERS,
  MENUITEMSFORPARTNER,
} from "../../../constants/menu";
import { connect } from "react-redux";
import "./sidebar.css";
import SubIcon from "./subIcons";
import { Tee, Onesie, Sock } from "../garments";

// image import
import logo from "../../../assets/images/brand/kido-logo.png";

// ── Category tones ─────────────────────────────────────────────
// Keyed by menu item title so the same category always gets the same
// toy-block colour, whichever role's menu it appears in. Tones map to the
// KIDO playroom palette in sidebar.css (.sb-tile--<tone>).
const ICON_TONE_MAP = {
  Dashboard: "sky",

  Orders: "lilac",
  "Pre Orders": "lilac",
  "Wholesale Management": "lilac",

  "Cash in/Cash out": "mint",
  "Cash in/out History": "mint",
  "Cash Summary": "mint",
  "Currency Converter": "mint",

  "Refund Requests": "peach",
  Coupons: "peach",

  Products: "butter",
  "Payment Request": "butter",

  Users: "sky",
  Admins: "lilac",
  "Steadfast Payments": "sky",
  "Register a manager": "peach",
  Localization: "mint",
  Settings: "ink",
};

const getIconTone = (title) => ICON_TONE_MAP[title] || "ink";

const MenuIcon = ({ item }) => (
  <span className={`sb-tile sb-tile--${getIconTone(item.title)}`} aria-hidden="true">
    <item.icon size={16} />
  </span>
);

export class sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPath: "1",
      mainmenu: [],
    };
  }

  onItemSelection = (arg, e) => {
    this.setState({ selectedPath: arg.path });
  };

  componentDidMount() {
    var currentUrl = window.location.pathname;
    console.log("i am called");
    if (this.props.currentAdmin && this.props.currentAdmin.status == "Admin") {
      this.setState({ mainmenu: MENUITEMSFORADMIN });
    } else if (this.props.currentAdmin && this.props.currentAdmin.status == "Partner") {
      this.setState({ mainmenu: MENUITEMSFORPARTNER });
    } else if (this.props.currentAdmin && this.props.currentAdmin.status == "Accounts") {
      this.setState({ mainmenu: MENUITEMSFORACCOUNTS });
    } else if (this.props.currentAdmin && this.props.currentAdmin.status == "Employee") {
      this.setState({ mainmenu: MENUITEMSFOREMPLOYEE });
    } else if (this.props.currentAdmin && this.props.currentAdmin.status == "Officer") {
      this.setState({ mainmenu: MENUITEMSFOROFFICERS });
    }

    this.state.mainmenu.filter((items) => {
      if (!items.children) {
        if (items.path === currentUrl) this.setNavActive(items);
        return false;
      }
      items.children.filter((subItems) => {
        if (subItems.path === currentUrl) this.setNavActive(subItems);
        if (!subItems.children) return false;
        subItems.children.filter((subSubItems) => {
          if (subSubItems.path === currentUrl) this.setNavActive(subSubItems);
        });
      });
    });
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.currentAdmin) {
      if (nextProps.currentAdmin.status == "Admin") {
        this.setState({ mainmenu: MENUITEMSFORADMIN });
      } else if (nextProps.currentAdmin.status == "Partner") {
        this.setState({ mainmenu: MENUITEMSFORPARTNER });
      } else if (nextProps.currentAdmin.status == "Accounts") {
        this.setState({ mainmenu: MENUITEMSFORACCOUNTS });
      } else if (nextProps.currentAdmin.status == "Employee") {
        this.setState({ mainmenu: MENUITEMSFOREMPLOYEE });
      } else if (nextProps.currentAdmin.status == "Officer") {
        this.setState({ mainmenu: MENUITEMSFOROFFICERS });
      }
    }
  };

  setNavActive(item) {
    if (this.props.currentAdmin && this.props.currentAdmin.status == "Admin") {
      MENUITEMSFORADMIN.filter((menuItem) => {
        if (menuItem != item) menuItem.active = false;
        if (menuItem.children && menuItem.children.includes(item))
          menuItem.active = true;
        if (menuItem.children) {
          menuItem.children.filter((submenuItems) => {
            if (submenuItems != item) {
              submenuItems.active = false;
            }
            if (submenuItems.children) {
              submenuItems.children.map((childItem) => {
                childItem.active = false;
              });
              if (submenuItems.children.includes(item)) {
                submenuItems.active = true;
                menuItem.active = true;
              }
            }
          });
        }
      });
      item.active = !item.active;
      this.setState({ mainmenu: MENUITEMSFORADMIN });
    } else if (this.props.currentAdmin && this.props.currentAdmin.status == "Employee") {
      MENUITEMSFOREMPLOYEE.filter((menuItem) => {
        if (menuItem != item) menuItem.active = false;
        if (menuItem.children && menuItem.children.includes(item))
          menuItem.active = true;
        if (menuItem.children) {
          menuItem.children.filter((submenuItems) => {
            if (submenuItems != item) {
              submenuItems.active = false;
            }
            if (submenuItems.children) {
              submenuItems.children.map((childItem) => {
                childItem.active = false;
              });
              if (submenuItems.children.includes(item)) {
                submenuItems.active = true;
                menuItem.active = true;
              }
            }
          });
        }
      });
      item.active = !item.active;
      this.setState({ mainmenu: MENUITEMSFOREMPLOYEE });
    } else if (this.props.currentAdmin && this.props.currentAdmin.status == "Accounts") {
      MENUITEMSFORACCOUNTS.filter((menuItem) => {
        if (menuItem != item) menuItem.active = false;
        if (menuItem.children && menuItem.children.includes(item))
          menuItem.active = true;
        if (menuItem.children) {
          menuItem.children.filter((submenuItems) => {
            if (submenuItems != item) {
              submenuItems.active = false;
            }
            if (submenuItems.children) {
              submenuItems.children.map((childItem) => {
                childItem.active = false;
              });
              if (submenuItems.children.includes(item)) {
                submenuItems.active = true;
                menuItem.active = true;
              }
            }
          });
        }
      });
      item.active = !item.active;
      this.setState({ mainmenu: MENUITEMSFORACCOUNTS });
    } else if (this.props.currentAdmin && this.props.currentAdmin.status == "Partner") {
      MENUITEMSFORPARTNER.filter((menuItem) => {
        if (menuItem != item) menuItem.active = false;
        if (menuItem.children && menuItem.children.includes(item))
          menuItem.active = true;
        if (menuItem.children) {
          menuItem.children.filter((submenuItems) => {
            if (submenuItems != item) submenuItems.active = false;
            if (submenuItems.children) {
              submenuItems.children.map((childItem) => { childItem.active = false; });
              if (submenuItems.children.includes(item)) {
                submenuItems.active = true;
                menuItem.active = true;
              }
            }
          });
        }
      });
      item.active = !item.active;
      this.setState({ mainmenu: MENUITEMSFORPARTNER });
    } else {
      MENUITEMSFOROFFICERS.filter((menuItem) => {
        if (menuItem != item) menuItem.active = false;
        if (menuItem.children && menuItem.children.includes(item))
          menuItem.active = true;
        if (menuItem.children) {
          menuItem.children.filter((submenuItems) => {
            if (submenuItems != item) {
              submenuItems.active = false;
            }
            if (submenuItems.children) {
              submenuItems.children.map((childItem) => {
                childItem.active = false;
              });
              if (submenuItems.children.includes(item)) {
                submenuItems.active = true;
                menuItem.active = true;
              }
            }
          });
        }
      });
      item.active = !item.active;
      this.setState({ mainmenu: MENUITEMSFOROFFICERS });
    }
  }

  render() {
    const mainmenu = this.state.mainmenu.map((menuItem, i) => (
      <li className={`${menuItem.active ? "active" : ""}`} key={i}>
        {menuItem.sidebartitle ? (
          <span className="sb-section-title">{menuItem.sidebartitle}</span>
        ) : null}

        {menuItem.type === "sub" ? (
          <a
            className="sidebar-header sb-menu-link"
            href="javascript:void(0)"
            onClick={() => this.setNavActive(menuItem)}
          >
            <MenuIcon item={menuItem} />
            <span>{menuItem.title}</span>
            <i className="fa fa-angle-right sb-arrow"></i>
          </a>
        ) : null}

        {menuItem.type === "link" ? (
          <Link
            to={`${process.env.PUBLIC_URL}${menuItem.path}`}
            className={`sidebar-header sb-menu-link ${menuItem.active ? "active" : ""}`}
            onClick={() => this.setNavActive(menuItem)}
          >
            <MenuIcon item={menuItem} />
            <span>{menuItem.title}</span>
            <i className="fa fa-angle-right sb-arrow"></i>
          </Link>
        ) : null}

        {menuItem.children ? (
          <ul
            className={`sidebar-submenu ${menuItem.active ? "menu-open" : ""}`}
          >
            {menuItem.children.map((childrenItem, index) => (
              <li
                key={index}
                className={childrenItem.children
                  ? childrenItem.active ? "active" : ""
                  : ""}
              >
                {childrenItem.type === "sub" ? (
                  <a
                    href="javascript:void(0)"
                    className="sb-sub-link"
                    onClick={() => this.setNavActive(childrenItem)}
                  >
                    <SubIcon title={childrenItem.title} />
                    {childrenItem.title}
                    <i className="fa fa-angle-right sb-arrow"></i>
                  </a>
                ) : null}

                {childrenItem.type === "link" ? (
                  <Link
                    to={`${process.env.PUBLIC_URL}${childrenItem.path}`}
                    className={`sb-sub-link ${childrenItem.active ? "active" : ""}`}
                    onClick={() => this.setNavActive(childrenItem)}
                  >
                    <SubIcon title={childrenItem.title} />
                    {childrenItem.title}
                  </Link>
                ) : null}

                {childrenItem.children ? (
                  <ul
                    className={`sidebar-submenu ${childrenItem.active ? "menu-open" : ""}`}
                  >
                    {childrenItem.children.map((childrenSubItem, key) => (
                      <li
                        className={childrenSubItem.active ? "active" : ""}
                        key={key}
                      >
                        {childrenSubItem.type === "link" ? (
                          <Link
                            to={`${process.env.PUBLIC_URL}${childrenSubItem.path}`}
                            className={`sb-sub-link ${childrenSubItem.active ? "active" : ""}`}
                            onClick={() => this.setNavActive(childrenSubItem)}
                          >
                            <SubIcon title={childrenSubItem.title} />
                            {childrenSubItem.title}
                          </Link>
                        ) : null}
                      </li>
                    ))}
                  </ul>
                ) : null}
              </li>
            ))}
          </ul>
        ) : null}
      </li>
    ));

    return (
      <Fragment>
        <div className="page-sidebar">
          <div className="main-header-left d-none d-lg-block">
            <div className="logo-wrapper">
              <Link to={`${process.env.PUBLIC_URL}/dashboard`}>
                <img
                  className="sb-logo"
                  src={logo}
                  alt="KIDO, where dreams begin"
                />
              </Link>
            </div>
          </div>
          <div className="sidebar custom-scrollbar">
            <User_panel />
            <ul className="sidebar-menu">{mainmenu}</ul>
            <svg
              className="sb-doodle"
              viewBox="0 0 220 90"
              aria-hidden="true"
              focusable="false"
            >
              <path d="M6 14 Q110 40 214 14" className="sb-doodle-line" />
              <g transform="translate(52 22) scale(0.7)">
                <Tee color="#CDEEFB" />
              </g>
              <g transform="translate(110 27) scale(0.7)">
                <Onesie color="#FFF0BF" />
              </g>
              <g transform="translate(166 22) scale(0.7)">
                <Sock color="#FFDCD2" />
              </g>
            </svg>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentAdmin: state.admins.currentAdmin,
  };
};

export default connect(mapStateToProps, null)(sidebar);
